import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  fetchStockVoteRoutine,
  toggleStockVoteRoutine
} from "../redux/modules/voting";
import { actions as alertActions } from "../redux/modules/alerts";
import { getVotingForStock } from "../redux/modules/voting/selector";

const useVoting = stockId => {
  const dispatch = useDispatch();
  const voting = useSelector(state => getVotingForStock(state, stockId));
  const voted = voting?.voted ?? null;

  useEffect(() => {
    if (stockId) {
      dispatch(fetchStockVoteRoutine({ stockId }));
    }
  }, [dispatch, stockId]);

  const refreshVote = useCallback(() => {
    if (stockId) {
      dispatch(fetchStockVoteRoutine({ stockId }));
    }
  }, [dispatch, stockId]);

  const toggleVote = useCallback(() => {
    if (stockId) {
      if (voted === true) {
        dispatch(
          alertActions.addWarningAlert({
            title: "You can't remove your vote"
          })
        );
        return;
      }

      dispatch(toggleStockVoteRoutine({ stockId }));
    }
  }, [dispatch, stockId, voted]);

  return {
    voted,
    weekStartDate: voting?.weekStartDate ?? null,
    loading: voting?.loading ?? false,
    error: voting?.error ?? null,
    refreshVote,
    toggleVote
  };
};

export default useVoting;

